module.exports = __webpack_public_path__ + "img/hungarytwo.5a4b7350.png";